import { MoreVertical, Pause, Pencil, Play, TestTube, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@shared/components/ui/shadcn/dropdown-menu';
import { WebhookEndpoint } from '../../models/Webhooks';

interface EndpointActionsMenuProps {
  endpoint: WebhookEndpoint;
  onEdit: (endpoint: WebhookEndpoint) => void;
  onTest: (id: number) => void;
  onToggleStatus: (
    id: number,
    url: WebhookEndpoint['url'],
    event_types: WebhookEndpoint['event_types'],
    currentStatus: WebhookEndpoint['status'],
  ) => void;
  onDelete: (id: number) => void;
}

export function EndpointActionsMenu({ endpoint, onEdit, onTest, onToggleStatus, onDelete }: EndpointActionsMenuProps) {
  const { t } = useTranslation('webhooksModule');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="inline-flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label={t('endpoints.actions.menu')}
        >
          <MoreVertical className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onEdit(endpoint)}>
          <Pencil className="mr-2 h-4 w-4" />
          {t('endpoints.actions.edit')}
        </DropdownMenuItem>

        <DropdownMenuItem onClick={() => onTest(endpoint.id)}>
          <TestTube className="mr-2 h-4 w-4" />
          {t('endpoints.actions.test')}
        </DropdownMenuItem>

        {endpoint.status === 'active' ? (
          <DropdownMenuItem
            onClick={() => onToggleStatus(endpoint.id, endpoint.url, endpoint.event_types, endpoint.status)}
          >
            <Pause className="mr-2 h-4 w-4" />
            {t('endpoints.actions.pause')}
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem
            onClick={() => onToggleStatus(endpoint.id, endpoint.url, endpoint.event_types, endpoint.status)}
          >
            <Play className="mr-2 h-4 w-4" />
            {t('endpoints.actions.activate')}
          </DropdownMenuItem>
        )}

        <DropdownMenuSeparator />

        <DropdownMenuItem onClick={() => onDelete(endpoint.id)} className="text-destructive focus:text-destructive">
          <Trash2 className="mr-2 h-4 w-4" />
          {t('endpoints.actions.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
